import { render, staticRenderFns } from "./HeatConsumption.global.vue?vue&type=template&id=0da2be72&scoped=true&lang=pug&"
import script from "./HeatConsumption.global.vue?vue&type=script&lang=ts&"
export * from "./HeatConsumption.global.vue?vue&type=script&lang=ts&"
import style0 from "./HeatConsumption.global.vue?vue&type=style&index=0&id=0da2be72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da2be72",
  null
  
)

export default component.exports